









































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { LinkCategory } from '../types'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    linkCategory: {
      type: Object as () => LinkCategory,
      default: () => ({
        fullpath: '/',
        icon_image: '~common/sidebar-all-categories.png',
        icon_image_alt: 'to top page',
        display_name: 'グッズ・ノベルティ'
      })
    },
    hasLinkCategory: {
      type: Boolean,
      required: true
    }
  }
})
